import { capitaliseFirstLetter } from './capitalise-first-letter';
import { wordsRegex } from './shared';
/**
 * Converts a given string to camel case.
 *
 * Examples:
 * - 'kebab-case' -> 'kebabCase'
 * - 'PascalCase' -> 'pascalCase'
 */
export const convertToCamelCase = (input) => {
    const words = input.match(wordsRegex);
    if (!words) {
        return '';
    }
    return words.reduce((acc, word, index) => {
        const lowerWord = word.toLowerCase();
        return acc + (index === 0 ? lowerWord : capitaliseFirstLetter(lowerWord));
    }, '');
};
//# sourceMappingURL=convert-to-camel-case.js.map